import CommentList from './CommentList';
import { Comment, Meta, postContentComments } from '../../apiService';
import CommentForm from './CommentForm';
import styled from '@emotion/styled';
import { useState } from 'react';
import { __t } from '../../i18n';
import usePagination from '../../usePagination';
import AlertService from '../../AlertService';
import { Text } from '../../styles';

export default function ContentComments({ initialData, initialUrl, contentId }: ContentCommentsProps) {
  const [state, setState] = useState({ loading: false, success: false });
  const { data, remainingItems, handleMore, loading, isValidating } = usePagination({ initialData, initialUrl });

  const handleSubmit = (comment: string) => {
    setState({ loading: true, success: false });
    if (contentId) {
      postContentComments({ contentId, comment }).then(
        () => {
          setState({ loading: false, success: true });
          AlertService.success(__t('comments.form.success'));
        },
        () => {
          setState({
            loading: false,
            success: false,
          });
        },
      );
    }
  };

  return (
    <CommentsWrapper>
      <Title />
      <CommentForm onSubmit={handleSubmit} state={state} />
      <CommentList
        contentId={contentId}
        comments={data}
        remaining={remainingItems}
        onShowMore={handleMore}
        loading={loading || isValidating}
      />
    </CommentsWrapper>
  );
}

const Title = () => (
  <Text variant="h2" weight="medium" align="center" mb={2}>
    {__t('comments.title')}
  </Text>
);

const CommentsWrapper = styled.section({
  margin: '0 auto',
  maxWidth: '57rem',
  display: 'flex',
  flexDirection: 'column',
});

type ContentCommentsProps = {
  initialData: {
    data: Comment[];
    meta: Meta;
  };
  initialUrl: string;
  contentId: string;
};
